import { connect } from 'react-redux'
import { showAppSnackbar } from './actions'

const mapDispatchToProps = {
  showAppSnackbar
}

export default options => WrappedComponent => (
  connect(null, mapDispatchToProps, null, options)(WrappedComponent)
)
